import { useEffect } from "react";

const useMountEffect = function(callback: () => void) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, []);
};

export default useMountEffect;
